module.exports = __webpack_public_path__ + "img/1.07ce97e7.png";